module.exports = "<div class=\"col-md-3 col-xs-12\"> <label class=q-label>{%- supplyChainFac.facName %}</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox checkboxTest q-checkbox checkbox-success cb-large\"> <input type=checkbox id=\"{%- supplyChainFac.facName %}\" value=\"{%- supplyChainFac.facName %}\" class=supply-chain-fac {% if(supplyChainFac.facDeactiveActive==\"1\") { %} checked=checked {% } %} /> <label for=\"{%- supplyChainFac.facName %}\"></label> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/maintainRetailer/html/splFacility.html
// module id = 1347
// module chunks = 1